import getters from './../Getters/projects.js';
import actions from './../Actions/projects.js';
import mutations from './../Mutations/projects.js';

export default {
    namespaced: true,

    state: {
        projects: [],

        currentProject: {
            numberOfSelectedFiles: 0,
            uploadStatus: null,
            projectData: {},
            rootFile: {},
            taskLists: [],
            feed: [],
            collaborators: [],
            assignedTaskLists: []
        },
    },

    getters,
    actions,
    mutations
};
